/* import __COLOCATED_TEMPLATE__ from './profile-menu.hbs'; */
import { action, computed, set } from '@ember/object';
import { attributeBindings, classNames, tagName } from '@ember-decorators/component';
import { isEmberTesting } from 'ember-simplepractice/utils/is-testing';
import { offset } from '@floating-ui/dom';
import { reads } from '@ember/object/computed';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './profile-menu.module.scss';

@classic
@tagName('button')
@classNames('profile-menu', styles.component)
@attributeBindings('data-test-profile-menu')
export default class ProfileMenu extends Component {
  styles = styles;

  @service('twilio/video-stream') videoStream;
  @service session;
  @service floatingUiElements;

  'data-test-profile-menu' = isEmberTesting();
  isTooltipShown = false;
  eventListeners = [
    { eventName: 'mouseenter', eventHandler: this.handleMouseEnter },
    { eventName: 'focus', eventHandler: this.handleMouseEnter },
    { eventName: 'mouseleave', eventHandler: this.handleMouseLeave },
    { eventName: 'blur', eventHandler: this.handleMouseLeave },
  ];

  @reads('session.isHost') isHost;
  @reads('session.userData') userData;
  @reads('userData.name') name;
  @reads('userData.profileImageUrl') profileImageUrl;
  @reads('floatingUiElements.controlsShown') controlsShown;
  @reads('floatingUiElements.profilePopoverShown') isPopoverShown;

  @computed('name', 'isHost')
  get shownName() {
    return `${this.name}${this.isHost ? ' (Host)' : ''}`;
  }

  @computed('showName')
  get popoverMiddleware() {
    return this.showName ? null : [offset({ crossAxis: -16 })];
  }

  @action
  handleMouseEnter() {
    set(this, 'isTooltipShown', true);
  }

  @action
  handleMouseLeave() {
    set(this, 'isTooltipShown', false);
  }

  @action
  handlePopoverChange(isShown) {
    this.floatingUiElements.setProfilePopoverVisibility(isShown);
    set(this, 'isTooltipShown', false);
  }

  didInsertElement() {
    super.didInsertElement(...arguments);
    this.eventListeners.forEach(({ eventName, eventHandler }) =>
      this.element.addEventListener(eventName, eventHandler)
    );
  }

  willDestroyElement() {
    super.willDestroyElement(...arguments);
    this.eventListeners.forEach(({ eventName, eventHandler }) =>
      this.element.removeEventListener(eventName, eventHandler)
    );
  }
}
